import React from 'react';
import { services } from '../data/mock';

const ServicesSection = () => {
  return (
    <section className="bg-[#0f0f10] py-16 sm:py-24">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6">
        <h2 
          className="text-2xl sm:text-3xl md:text-4xl text-white text-center mb-10 sm:mb-16"
          style={{ fontFamily: 'Playfair Display, serif' }}
        >
          Une solution adaptée à vos besoins
        </h2>

        <div className="space-y-0">
          {services.map((service, index) => (
            <div 
              key={service.id}
              className="py-8 sm:py-12 border-t border-gray-800 last:border-b group"
            >
              <div className={`flex flex-col lg:flex-row items-center gap-6 sm:gap-12 ${
                index % 2 === 1 ? 'lg:flex-row-reverse' : ''
              }`}>
                {/* Content */}
                <div className="lg:w-1/2 text-center lg:text-left">
                  <h3 
                    className="text-xl sm:text-2xl md:text-3xl text-white mb-3 sm:mb-4 transition-transform duration-300 group-hover:translate-x-2"
                    style={{ fontFamily: 'Playfair Display, serif' }}
                  >
                    {service.title}
                  </h3>
                  <p className="text-gray-400 leading-relaxed text-sm sm:text-base">
                    {service.description}
                  </p>
                </div>

                {/* Image */}
                <div className="lg:w-1/2 w-full">
                  <div className="relative overflow-hidden rounded-xl shadow-xl">
                    <img
                      src={service.image}
                      alt={service.title}
                      className="w-full h-56 sm:h-72 lg:h-80 object-cover transition-transform duration-700 group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
